<div class="app-container">
  <div class="app-content">
    <div class="container">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
